import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage';
import UserAuthentication from './UserAuthentication';
import ShowAlert from './Alert';
import ShowLoader from './PageLoader'
import Config from './Configuration'
import MapReducer from "./MapReducer";


const persistToken = {
    key: 'Token',
    storage,
}

const persistConfig = {
    key: 'Config',
    storage,
}

const persistMap = {
    key: 'Config',
    storage,
}


const persistedReducer = persistReducer(persistToken, UserAuthentication);
const persistedConfig = persistReducer(persistConfig, Config);
const persistedMap = persistReducer(persistMap, MapReducer);


const AllReducers = combineReducers({
    UserAuthentication: persistedReducer,
    ShowAlert: ShowAlert,
    ShowLoader: ShowLoader,
    MapReducer: persistedMap,
    Config: persistedConfig,
})

export default AllReducers;